export default {"src":"/_next/static/media/grin.5969fbbe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};